import {createAction, handleActions} from 'redux-actions';
// import {ofType} from 'redux-observable';
// import { mapTo} from 'rxjs/operators';
// import {Api} from "../../api/api";
import _ from 'lodash';
import {translations} from "../../translations";
import {StorageApi} from "../../utils/storageApi";
// import {logout, onForbidden} from "../account/login";
import moment from 'moment';

//- Actions
export const setSelectedLanguage = createAction('SELECTED_LANGUAGE_SET', language => language);

// TODO: use it when improve localization in future
// export const fetchGetTranslationsSuccess = createAction('FETCH_GET_TRANSLATIONS_SUCCESS');
// export const fetchGetTranslationsFailed = createAction('FETCH_GET_TRANSLATIONS_FAILED');
// export const fetchGetTranslations = createAction(
//     'FETCH_GET_TRANSLATIONS',
//     () => Api.getTranslations(),
//     () => ({
//         apiCall: true,
//         onSuccess: fetchGetTranslationsSuccess,
//         onFail: fetchGetTranslationsFailed,
//         onUnauthorized: logout,
//         onForbidden: onForbidden
//     })
// );
//
// export const fetchGetTranslationFailed = createAction('FETCH_GET_TRANSLATION_FAILED');
// export const fetchGetTranslationSuccess = createAction('FETCH_GET_TRANSLATION_SUCCESS');
// export const fetchGetTranslationByPath = createAction(
//     'FETCH_GET_TRANSLATION',
//     (path) => Api.getTranslationByPath(path),
//     () => ({
//         apiCall: true,
//         onSuccess: fetchGetTranslationSuccess,
//         onFail: fetchGetTranslationFailed,
//         onUnauthorized: logout,
//         onForbidden: onForbidden
//     })
// );
//
// export const loadLanguage = (topLanguage, languages) => (dispatch, getState) => {
//     let newLanguage = StorageApi.getLanguage();
//     let translations = getTranslations(getState());
//     if (_.isNil(newLanguage)) {
//         if (_.isArray(languages)) {
//             newLanguage = _.find(languages, language => _.includes(_.keys(translations), language.substring(0, 2))).substring(0,2) || DEFAULT_LANGUAGE;
//         } else if (!_.isNil(topLanguage) && _.includes(_.keys(translations), topLanguage.substring(0, 2))) {
//             newLanguage = topLanguage.substring(0, 2);
//         } else {
//             newLanguage = DEFAULT_LANGUAGE;
//         }
//     }
//     if(_.includes(_.keys(translations), newLanguage)) {
//         dispatch(setSelectedLanguage(newLanguage));
//         dispatch(fetchGetTranslationByPath(translations[newLanguage].path));
//     }
// };

export const getDefaultLanguage = () => {
    let newLanguage = StorageApi.getLanguage();
    if (_.isNil(newLanguage)) {
        let topLanguage = window.navigator.language;
        let languages = window.navigator.languages;
        if (_.isArray(languages)) {
            newLanguage = _.find(languages, language => _.includes(_.keys(translations), language.substring(0, 2))).substring(0, 2) || DEFAULT_LANGUAGE;
        } else if (!_.isNil(topLanguage) && _.includes(_.keys(translations), topLanguage.substring(0, 2))) {
            newLanguage = topLanguage.substring(0, 2);
        } else {
            newLanguage = DEFAULT_LANGUAGE;
        }
    }
    return newLanguage;
};

export const sharedLabelsPath = {
    errors: 'errors',
    defaultError: 'errors.DEFAULT_ERROR',
    add_button: 'shared.add_button',
    cancel_button: 'shared.cancel_button',
    remove_button: 'shared.remove_button',
    first_name_label: "shared.first_name_label",
    last_name_label: "shared.last_name_label",
    email_label: "shared.email_label",
    personal_email_label: "shared.personal_email_label",
    professional_email_label: "shared.professional_email_label",
    password_label: "shared.password_label",
    department_label: "shared.department_label",
    continent_input_placeholder: "shared.continent_input_placeholder",
    country_input_placeholder: "shared.country_input_placeholder",
    continent_label: "shared.continent_label",
    continent_filter_label: "shared.continent_filter_label",
    country_label: "shared.country_label",
    fetching_message: "shared.fetching_message",
    success_message: "shared.success_message",
    national_id_label: "shared.national_id_label",
    continents: "continents",
    countries: "countries",
    company_label: "shared.company_label",
    edu_org_label: "shared.edu_org_label",
    employee_count_label: "shared.employee_count_label",
    name_label: "shared.name_label",
    accreditation_group_label: "shared.accreditation_group_label",
    okey_button: "shared.okey_button",
    yes_label: "shared.yes_label",
    no_label: "shared.no_label",
    org_label: "shared.org_label",
    edit_button: "shared.edit_button",
    datepicker_placeholder: "shared.datepicker_placeholder",
    save_changes_button: "shared.save_changes_button",
    domain_label: "shared.domain_label",
    back_button: "shared.back_button",
    company_domain_label: "shared.company_domain_label",
    search_label: "shared.search_label",
    about_label: "shared.about_label",
    title_label: "shared.title_label",
    phone_number_label: "shared.phone_number_label",
    required_field_error_message: "shared.required_field_error_message",
    pages_label: "shared.pages_label",
    examples_label: "shared.examples_label",
    location_label: "shared.location_label",
    all_label: "shared.all_label",
    filter_options_label: "shared.filter_options_label"
};

export const changeLanguage = (language) => (dispatch) => {
    dispatch(setSelectedLanguage(language));
    // dispatch(fetchGetTranslationByPath(getPathByLanguageCode(getState(), language)));
    StorageApi.setLanguage(language);
};

const DEFAULT_LANGUAGE = 'en';
const DEFAULT_MOMENT_LOCALE = 'en-gb';
// moment.locale(_.isNil(lastSelectedLanguage) ? DEFAULT_LANGUAGE : lastSelectedLanguage);
//- State
const initialState = {
    fetching: false,
    error: null,
    selectedLanguage: DEFAULT_LANGUAGE,
    translation: null,
    translations
};

//- Reducers
export default handleActions({
    // TODO: use it when improve localization in future
    // FETCH_GET_TRANSLATION: (state) => {
    //     return {...state, fetching: true, translation: null, error: null};
    // },
    // FETCH_GET_TRANSLATION_FAILED: (state, action) => {
    //     return {...state, fetching: false, translation: null, error: action.payload};
    // },
    // FETCH_GET_TRANSLATION_SUCCESS: (state, action) => {
    //     return {...state, fetching: false, translation: action.payload, error: null};
    // },
    // FETCH_GET_TRANSLATIONS: (state) => {
    //     return {...state, fetching: true, translations: null, error: null};
    // },
    // FETCH_GET_TRANSLATIONS_FAILED: (state, action) => {
    //     return {...state, translations: null, error: action.payload};
    // },
    // FETCH_GET_TRANSLATIONS_SUCCESS: (state, action) => {
    //     return {...state, translations: action.payload, error: null};
    // },
    SELECTED_LANGUAGE_SET: (state, action) => {
        let languageCode = action.payload;
        if (_.has(state.translations, languageCode)) {
            let locale = state.translations[languageCode].momentLocale;
            _.includes(moment.locales(), locale) ? moment.locale(locale) : moment.locale(DEFAULT_MOMENT_LOCALE);
        } else {
            languageCode = DEFAULT_LANGUAGE;
            moment.locale(DEFAULT_MOMENT_LOCALE);
        }

        return {...state, selectedLanguage: languageCode};
    }
}, initialState);

//- Epics
// TODO: use it when improve localization in future
// export const getTranslationsSuccessEpic = (action$) => {
//     return action$.pipe(
//         ofType('FETCH_GET_TRANSLATIONS_SUCCESS'),
//         mapTo(loadLanguage(window.navigator.language, window.navigator.languages)))
//     };

//- Selectors
export const getLocalizationData = state => state.localization;

export const getSelectedLanguage = state => getLocalizationData(state).selectedLanguage;

export const loadingTranslation = state => getLocalizationData(state).fetching;

export const getTranslations = state => getLocalizationData(state).translations;

export const getSelectedTranslation = state => _.isNil(getTranslations(state)) || !_.has(getTranslations(state), getSelectedLanguage(state)) ? null : getTranslations(state)[getSelectedLanguage(state)];

export const getTranslation = state => _.isNil(getSelectedTranslation(state)) ? null : getSelectedTranslation(state).translation;

export const getTranslationsList = state => {
    return _.chain(getTranslations(state))
        .map((translation, key) => ({value: key, label: key.toUpperCase(), title: translation.label}))
        .value();
};

// TODO: use it when improve localization in future
// export const getPathByLanguageCode = (state, languageCode) => {
//     let translation = _.find(getLocalizationData(state).translations, (translation, code) => code === languageCode);
//
//     if (_.isNil(translation)) {
//         return null;
//     }
//
//     return translation.path;
// } ;


// WEBPACK FOOTER //
// ./src/reducers/common/localization.js